<!-- //
字典列表
@author xuyd
@date 2025-05-31
//-->
<template>
  <page-layout layout="C">
    <!-- 搜索区域 -->
    <div class="layout-search flex-row flex-halign-between">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="90px" size="small"
               @submit.native.prevent>
        <el-row>
          <el-form-item label="检索内容" prop="search">
            <el-input v-model="queryParams.search" placeholder="请输入字典类型/类型名称/字典值/字典显示内容" style="width: 400px" clearable
                      maxlength="100"
                      @keyup.enter.native="handleQuery"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <div style="display: flex;">
        <div>
          <el-button size="small" type="danger" @click="handleRefresh">刷新字典</el-button>
        </div>
      </div>
    </div>
    <!-- 结果区域 -->
    <div class="layout-result" style="height: calc(100% - 63px);">
      <el-table ref="refTable" v-loading="tableLoading" :data="list"
                border
                height="100%"
                size="medium"
                :header-cell-style="this.tableHeader">
        <el-table-column header-align="left" label="字典类型" align="left" min-width="180" prop="dictType"/>
        <el-table-column header-align="left" label="类型名称" align="left" min-width="180" prop="typeName"/>
        <el-table-column header-align="left" label="字典值" align="left" min-width="100" prop="dictValue"/>
        <el-table-column header-align="left" label="字典显示内容" align="left" min-width="200" prop="dictLabel"/>
        <el-table-column header-align="left" label="字典样式" align="left" min-width="100" prop="dictStyle"
                         :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <el-tag :type="row.dictStyle" v-if="row.dictStyle">
              {{ row.dictStyle }}
            </el-tag>
            <span v-else>{{ row.dictStyle }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="left" label="状态" align="left" width="80" prop="status">
          <template slot-scope="{row}">
            <dict-tag dictType="YES_OR_NO" :value="row.status" :options="{type: 'tag'}"/>
          </template>
        </el-table-column>
        <el-table-column header-align="left" label="操作" align="left" width="150">
          <template slot-scope="{row}">
            <el-button size="small" type="text" @click="handleModify(row)">编辑</el-button>
            <el-button size="small" type="text" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination :total="total" :pageNum.sync="queryParams.pageNum" :pageSize.sync="queryParams.pageSize"
                  @pagination="getList"/>
    </div>
    <DetailDialog ref="refDetailDialog"/>
  </page-layout>
</template>
<script>
import DictApi from "@/api/sys/sysDict.api.js";
import DetailDialog from "./detail";

export default {
  name: 'ViewDictList',
  components: {DetailDialog},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
  ],
  data() {
    return {
      // 遮罩层
      tableLoading: false,
      loading: false,

      // 总条数
      list: [],
      total: 0,

      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        search: null,
        orderByColumn: null,
        isAsc: null,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {

    /** 查询列表 */
    getList() {
      this.tableLoading = true;
      DictApi.searchDictList(this.queryParams).then((resp) => {
        this.list = resp.data.records;
        this.total = resp.data.total;
        this.tableLoading = false;
      }).catch(err => {
        this.tableLoading = false;
      });
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },

    /** 新增 */
    handleAdd() {
      this.$refs.refDetailProgramDialog.showModal({
        mode: 1,
        title: '添加',
        data: {},
        onOk: () => {
          this.getList();
        }
      });
    },

    /** 编辑 */
    handleModify(row) {
      this.$refs.refDetailDialog.showModal({
        mode: 2,
        title: '修改',
        data: {...row},
        onOk: () => {
          this.getList();
        }
      });
    },
    /** 删除 */
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.appName}】吗？`).then(() => {
        DictApi.deleteDict(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },
    /** 刷新 */
    handleRefresh() {
      this.$modal.confirm(`确定要刷新全部字典吗？`).then(() => {
        DictApi.refreshDictCache().then(resp => {
          this.$modal.msgSuccess('刷新成功');
          this.getList();
        })
      })
    },
  },
};
</script>

<style lang="less" scoped>
</style>
